import { Typography, Stack, useTheme } from '@mui/material'
import { i18WithDefault as t } from '@shared/locales'
import { formatDate, formatAmPm, dayToJSDate, getDOWFromStr } from '@shared/dates'
import {
  displayHoursInPeriodRestrictions,
  isSelectedDayInPeriodRestrictions,
  isSelectedDateInPeriodRestrictionsRelation,
} from '@shared/restrictions'
import { FeeStructure } from './fee_structure'
import { PaymentSettingAdminDto } from 'service-api/src/types'
import { Types } from 'service-api'

export interface LateDepartureDetailsProps {
  endDate?: string
  endTime?: string | null
  order: Types.OrderClientDto
  bookingConfig: Types.BookingConfigsClientDto
  header?: string
}

export const LateDepartureDetails = ({
  endDate,
  endTime,
  order,
  bookingConfig,
  header: customHeader,
}: LateDepartureDetailsProps) => {
  const { locationBookingConf, checkOutHour, operationHour } = bookingConfig
  const theme = useTheme()
  const checkOutDay = endDate && getDOWFromStr(endDate)

  const lateDeparture = (
    order?.data as Record<string, PaymentSettingAdminDto[]> | undefined
  )?.surchargeSettings?.filter(
    (fee: PaymentSettingAdminDto) =>
      fee?.after &&
      checkOutDay &&
      isSelectedDateInPeriodRestrictionsRelation(fee.restrictionRelations!, checkOutDay, endDate) &&
      (locationBookingConf?.surchargeStrategy === 'ENFORCED' || locationBookingConf?.surchargeStrategy === 'DURATION')
  ) as PaymentSettingAdminDto[]
  const isCheckOutEnabled =
    checkOutHour &&
    checkOutDay &&
    isSelectedDayInPeriodRestrictions(checkOutHour, checkOutDay) &&
    (locationBookingConf?.surchargeStrategy === 'SUGGESTED' || locationBookingConf?.surchargeStrategy === 'ENFORCED')

  const defaultLateDepartureHeader = `${t('surchargePolicy.departure')}: ${formatDate(dayToJSDate(endDate))} ${
    endTime ? formatAmPm(endTime) : ''
  }`

  return (
    <Stack sx={{ border: `1px solid ${theme.palette.divider}`, p: 2, borderRadius: 1 }}>
      {endDate && (
        <Typography variant="body1" style={{ fontWeight: 700 }}>
          {customHeader || defaultLateDepartureHeader}
        </Typography>
      )}
      {checkOutDay && operationHour && (
        <Typography variant="caption" style={{ fontStyle: 'italic', color: theme.palette.text.secondaryShade60 }}>
          {t('surchargePolicy.open')}: {displayHoursInPeriodRestrictions(operationHour, checkOutDay)}
        </Typography>
      )}
      {isCheckOutEnabled && checkOutDay && (
        <Typography variant="body2" mb={1}>
          <strong>{t('surchargePolicy.checkOutHours')}:</strong>{' '}
          {displayHoursInPeriodRestrictions(checkOutHour!, checkOutDay)}
        </Typography>
      )}
      {!!lateDeparture?.length && <FeeStructure type="lateDeparture" fees={lateDeparture} />}
    </Stack>
  )
}
